export const Features = {
	skipRevocationRight: "skipRevocationRight",
	accountNumberValidation: "accountNumberValidation",
	additionalAccount: "additionalAccount",
	askForConsultantEmailAddress: "askForConsultantEmailAddress",
	askForKundennummer: "askForKundennummer",
	asyncProcessing: "asyncProcessing",
	checkCreditorChange: "checkCreditorChange",
	foreignResidenceCheck: "foreignResidenceCheck",
	hasFeedbackModal: "hasFeedbackModal",
	hasStatusPage: "hasStatusPage",
	showTransferInfoIcon: "showTransferInfoIcon",
	switchDeadlineInDays: "switchDeadlineInDays",
	investmentAccountUrl: "investmentAccountUrl",
	isTinRequired: "isTinRequired",
	ownAccountTransferPrechecked: "ownAccountTransferPrechecked",
	prefillBankCode: "prefillBankCode",
	proceedsOnClearingAccount: "proceedsOnClearingAccount",
	securitiesAccountUrl: "securitiesAccountUrl",
	showBlzInput: "showBlzInput",
	showFinanceType: "showFinanceType",
	showFinanceTypeInfo: "showFinanceTypeInfo",
	showFinoLogoInHeader: "showFinoLogoInHeader",
	showHeadline: "showHeadline",
	showHelpItem: "showHelpItem",
	showNewPortfolioNeededInfo: "showNewPortfolioNeededInfo",
	showSignaturePad: "showSignaturePad",
	showStartOpenSecuritiesAccountInfo: "showStartOpenSecuritiesAccountInfo",
	transferTypes: "transferTypes",
	userDataReadOnly: "userDataReadOnly",
	userEmail: "userEmail",
	USWithholdingTaxCheck: "USWithholdingTaxCheck",
	tradeRepublicUnsupportedHint: "tradeRepublicUnsupportedHint",
};



// WEBPACK FOOTER //
// ./src/app/common/config/feature.constants.js